import { TAjaxFormResponseContainerInstance } from 'widgets/forms/AjaxFormResponseContainer';

/**
 * @param AjaxForm Base widget for extending
 * @returns LoginForm widget
 */
function LoginFormClassCreator(AjaxForm: import('widgets/forms/AjaxForm').TAjaxForm) {
    /**
     * @category widgets
     * @subcategory forms
     * @class LoginForm
     * @augments AjaxForm
     * @classdesc Represents LoginForm component with next features:
     * 1. Show password reset modal on click
     * @property {string} data-widget - Widget name `loginForm`
     * @example <caption>Example of LoginForm widget usage</caption>
     *  <form
     *      action="${pdict.actionUrl}"
     *      class="b-form m-login"
     *      method="POST"
     *      name="login-form"
     *      data-widget="loginForm"
     *      data-event-submit.prevent="handleSubmit"
     *      novalidate
     *  >
     *      ... form content
     *
     *      <div class="b-reset_password">
     *          ... reset password modal content
     *      </div>
     *  </form>
     */
    class LoginForm extends AjaxForm {
        /**
         * @description Show password reset modal
         * @listens dom#click
         */
        passwordReset(): void {
            this.getById(
                'ajaxFormResponseContainer',
                (ajaxFormResponseContainer: TAjaxFormResponseContainerInstance) => ajaxFormResponseContainer.showModal({})
            );
        }

        /**
         * @description Show and render password reset migrate modal
         * @param data - response data for render migrate modal
         */
        passwordResetForMigratedCustomers(data: TServerResponse): void {
            this.getById(
                'modalForMigratedCustomer',
                (modalForMigratedCustomer: TAjaxFormResponseContainerInstance) => modalForMigratedCustomer.showModal(data)
            );
        }

        /**
         * @description Handles server response
         * @param data Server JSON response once form submitted
         */
        onSubmitted(data: TServerResponse & { showPasswordResetModalForMigratedCustomer: boolean }): void {
            if (data.showPasswordResetModalForMigratedCustomer) {
                this.passwordResetForMigratedCustomers(data);
            } else {
                super.onSubmitted(data);
            }
        }
    }

    return LoginForm;
}

export type TLoginForm = ReturnType<typeof LoginFormClassCreator>;

export type TLoginFormInstance = InstanceType<TLoginForm>;

export default LoginFormClassCreator;
